import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CpRadioModule } from '../radio/radio.module';
import { CurrencyValueAccessor } from './currency.directive';
import { DateValueAccessor } from './date.directive';
import { CpError } from './error.directive';
import { CpFormFieldComponent } from './form-field.component';
import { CpInput } from './input.directive';
import { CpLabel } from './label.directive';
import { CpSuffix } from './suffix.directive';
import { PercentageValueAccessor } from './percent.directive';
import { CpSelect } from './select.directive';
import { CpFooter } from './footer.directive';

@NgModule({
  declarations: [
    CpFormFieldComponent,
    CpError,
    CpInput,
    CpSelect,
    CpLabel,
    CpSuffix,
    CpFooter,
    CurrencyValueAccessor,
    DateValueAccessor,
    PercentageValueAccessor,
  ],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgSelectModule, CpRadioModule],
  providers: [],
  exports: [
    CpFormFieldComponent,
    CpError,
    CpInput,
    CpSelect,
    CpLabel,
    CpSuffix,
    CpFooter,
    CurrencyValueAccessor,
    DateValueAccessor,
    PercentageValueAccessor,
  ],
})
export class CpFormFieldModule {}
